export type GiftCard = {
  code: string;
  status?: GIFT_CARD_STATUS;
  customerId: string | null;
  createdAt: string | null;
  orderId?: string;
  uuid: string | null;
};

export type Customer = {
  firstName: string | null;
  lastName: string | null;
  customerID: string;
};

export enum GIFT_CARD_STATUS {
  CANCELLED = 'cancelled',
  ACTIVE = 'active',
  EXPIRED = 'expired',
  REDEEMED = 'redeemed',
  RESET = 'reset',
  RECYCLED = 'recycled',
  TRANSFERRED = 'transferred',
  AWAITING_ACTIVATION = 'awaiting_activation',
}
